export interface SelectionRequest<Key> {
  readonly key: Key;
  readonly version: number;
}

export interface LatestSelectionTracker<Key> {
  select: (key: Key) => SelectionRequest<Key>;
  invalidate: () => void;
  isCurrent: (request: SelectionRequest<Key>) => boolean;
  isSelected: (key: Key) => boolean;
}

export function createLatestSelectionTracker<
  Key,
>(): LatestSelectionTracker<Key> {
  let selected: Key | null = null;
  let version = 0;

  return {
    select(key) {
      selected = key;
      version += 1;
      return { key, version };
    },
    invalidate() {
      selected = null;
      version += 1;
    },
    isCurrent(request) {
      return selected === request.key && version === request.version;
    },
    isSelected(key) {
      return selected === key;
    },
  };
}

export function isCurrentSelection<Key>(
  tracker: LatestSelectionTracker<Key>,
  selectedKey: Key | null,
  detailKey: Key,
): boolean {
  return selectedKey === detailKey && tracker.isSelected(detailKey);
}
